import HttpClient from 'flow-doctor-lib/constants/HttpClient';
// AD
export const fetchAdReferencesByIds = (portalId, ids) => {
  return HttpClient.post('crm-search/search', {
    query: {
      portalId
    },
    data: {
      portalId,
      count: ids.length,
      offset: 0,
      query: '',
      requestOptions: {
        includeAllValues: true
      },
      sorts: [{
        property: 'hs_name',
        order: 'ASC'
      }],
      filterGroups: [{
        filters: [{
          property: 'hs_ad_id',
          values: ids,
          operator: 'IN'
        }]
      }],
      objectTypeId: 'AD'
    }
  }).then(resp => resp.results.reduce((acc, ad) => Object.assign({}, acc, {
    [ad.properties.hs_ad_id.value]: ad.properties.hs_name.value
  }), {}));
};

// AD_CAMPAIGN
export const fetchAdCampaignReferencesByIds = (portalId, ids) => {
  return HttpClient.post('crm-search/search', {
    query: {
      portalId
    },
    data: {
      portalId,
      count: ids.length,
      offset: 0,
      query: '',
      requestOptions: {
        includeAllValues: true
      },
      sorts: [{
        property: 'hs_name',
        order: 'ASC'
      }],
      filterGroups: [{
        filters: [{
          property: 'hs_ad_campaign_id',
          values: ids,
          operator: 'IN'
        }]
      }],
      objectTypeId: 'AD_CAMPAIGN'
    }
  }).then(resp => resp.results.reduce((acc, ad) => Object.assign({}, acc, {
    [ad.properties.hs_ad_campaign_id.value]: ad.properties.hs_name.value
  }), {}));
};

// AD_GROUP
export const fetchAdGroupReferencesByIds = (portalId, ids) => {
  return HttpClient.post('crm-search/search', {
    query: {
      portalId
    },
    data: {
      portalId,
      count: ids.length,
      offset: 0,
      query: '',
      requestOptions: {
        includeAllValues: true
      },
      sorts: [{
        property: 'hs_name',
        order: 'ASC'
      }],
      filterGroups: [{
        filters: [{
          property: 'hs_ad_group_id',
          values: ids,
          operator: 'IN'
        }]
      }],
      objectTypeId: 'AD_GROUP'
    }
  }).then(resp => resp.results.reduce((acc, ad) => Object.assign({}, acc, {
    [ad.properties.hs_ad_group_id.value]: ad.properties.hs_name.value
  }), {}));
};
// AUTOMATION_PLATFORM_WORKFLOWS
export const fetchWorkflowReferencesByIds = (portalId, ids) => {
  return HttpClient.get('automationapps/v1/summaries', {
    query: {
      portalId,
      flowIds: ids
    }
  }).then(resp => resp.results.reduce((acc, flow) => Object.assign({}, acc, {
    [flow.flowId]: flow.name
  }), {}));
};

// There are other fields, but we don't need them

// CTA_GUID
export const fetchCTAReferencesByGuidIds = (portalId, ids) => {
  const idSet = new Set(ids);
  return HttpClient.get('ctas/v3/ctas', {
    query: {
      portalId
    }
  }).then(resp => resp.results.filter(cta => idSet.has(cta.guid)).reduce((acc, cta) => Object.assign({}, acc, {
    [cta.guid]: cta.name
  }), {}));
};

// EMAIL_CAMPAIGN
export const fetchEmailCampaignReferencesByIds = (portalId, ids) => {
  return HttpClient.put('cosemail/v1/emails/search/by-ids', {
    query: {
      portalId
    },
    data: {
      emailCampaignIds: ids
    }
  }).then(resp => Object.keys(resp).reduce((acc, id) => Object.assign({}, acc, {
    [id]: resp[id].name
  }), {}));
};

// FORM
export const fetchFormReferencesByIds = (portalId, ids) => HttpClient.get('forms/v2/forms/batch', {
  query: {
    portalId,
    guid: ids
  }
}).then(resp => resp.reduce((acc, form) => Object.assign({}, acc, {
  [form.guid]: form.name
}), {}));

// SITE_CONTENT
export const fetchPageReferencesById = (portalId, ids) => {
  return HttpClient.get('content/api/v4/contents', {
    query: {
      portalId,
      limit: ids.length,
      includeDeleted: true,
      analyticsPageId__in: ids.toString()
    }
  }).then(resp => resp.objects.reduce((acc, page) => Object.assign({}, acc, {
    [page.analyticsPageId]: page.label
  }), {}));
};